import { option } from 'fp-ts';
import { type Eq, eqStrict } from 'fp-ts/lib/Eq';
import type { Option } from 'fp-ts/lib/Option';

import { ___, partialApply } from './partialApply';

/**
 * Return first element of an array when all elements in the array are equal,
 * return None if not or for empty array.
 */
export const onlyValue =
  <T>(eq: Eq<T> = eqStrict) =>
  (a: readonly T[]): Option<T> => {
    if (a[0] === undefined) {
      return option.none;
    }

    const first = a[0];
    return a.slice(1).every(partialApply(eq.equals, first, ___))
      ? option.some(first)
      : option.none;
  };
